// qs-Logo.vue
<template>
  <div class="logo-container" :style="{ width: size + 'px', height: size + 'px' }">
    <svg 
      :width="size" 
      :height="size" 
      viewBox="0 0 1024 1024" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      class="logo-svg"
    >
      
      <circle cx="512" cy="512" r="500" class="fill-creme" />
      
      
      <g class="logo-circles">
        <circle
          v-for="(circle, index) in circles"
          :key="`circle-${index}`"
          :cx="circle.cx"
          :cy="circle.cy"
          :r="circle.r"
          :fill="circle.fill"
          :stroke="circle.stroke"
          :stroke-width="circle.strokeWidth"
        />
      </g>

<g class="logo-pen1">
<path d="M19.3207 173.05C17.0307 197.11 11.1807 262.55 11.1807 301.54V314.23H58.8307V301.54C58.8307 266.1 52.9107 197.84 50.6507 173.05H19.3207Z" fill="white"/>
<path d="M60.0004 162.78H53.4704C55.3504 156.3 67.8604 112.09 67.8604 79.6498C67.8604 44.5598 31.3004 0.779785 31.3004 0.779785C31.3004 41.4698 3.0004 55.7398 3.0004 90.5798C3.0004 122.43 14.7104 157.07 16.7204 162.78H9.99039C9.99039 162.78 0.900391 252.25 0.900391 301.54V503.63C0.900391 635.37 13.3604 1027.28 16.0904 1111.66C16.3804 1120.65 23.7504 1127.78 32.7504 1127.78H37.2404C46.2404 1127.78 53.6104 1120.65 53.9004 1111.66C56.6304 1027.35 69.0904 635.99 69.0904 503.63V301.54C69.0904 256.95 60.0004 162.78 60.0004 162.78ZM58.8304 344.68H11.1804V324.5H58.8304V344.68ZM58.8304 314.23H11.1804V301.54C11.1804 262.55 17.0404 197.11 19.3204 173.05H50.6504C52.9104 197.85 58.8304 266.1 58.8304 301.54V314.23Z" fill="black"/>
<path d="M58.8199 324.5H11.1699V344.68H58.8199V324.5Z" fill="white"/>
</g>

<g class="logo-pen2">
<path d="M19.3197 177.77C17.0297 201.83 11.1797 267.27 11.1797 306.26V318.95H58.8297V306.26C58.8297 270.82 52.9097 202.56 50.6497 177.77H19.3197Z" fill="white"/>
<path d="M58.8199 329.22H11.1699V349.4H58.8199V329.22Z" fill="white"/>
<path d="M69.0999 359.67V306.26C69.0999 261.67 60.0099 167.5 60.0099 167.5H57.4799C57.9999 163.15 58.5099 158.86 59.0399 154.58C60.2899 144.42 61.5599 134.27 62.8099 124.11C64.1699 113.11 65.3999 102.1 66.9199 91.1199C67.9599 83.5999 66.8399 76.6799 63.0499 70.0199C52.0199 50.6499 44.0199 30.0699 38.8799 8.37991C38.7299 7.72991 38.8399 6.91992 39.0899 6.28992C40.0799 3.78992 39.0399 0.399902 35.0099 0.399902C30.9799 0.399902 30.0199 3.80991 30.9799 6.24991C31.2399 6.91991 31.3699 7.77991 31.1999 8.46991C26.0099 30.2999 17.8899 50.9899 6.80991 70.4999C3.71991 75.9499 2.25989 81.6999 2.85989 87.9399C3.07989 90.2599 3.4299 92.5699 3.7099 94.8899C4.7499 103.37 5.76991 111.86 6.80991 120.34C7.75991 128.08 8.72991 135.82 9.68991 143.56C10.6699 151.5 11.6399 159.44 12.6299 167.49H10.0099C10.0099 167.49 0.919922 256.96 0.919922 306.25V359.66V508.34C0.919922 640.08 13.3799 1031.99 16.1099 1116.37C16.3999 1125.36 23.7699 1132.49 32.7699 1132.49H37.2599C46.2599 1132.49 53.6299 1125.36 53.9199 1116.37C56.6499 1032.06 69.1099 640.7 69.1099 508.34V359.66L69.0999 359.67ZM35.0399 76.7699C39.2099 76.7699 42.5799 80.1499 42.5799 84.3099C42.5799 88.4699 39.1999 91.8499 35.0399 91.8499C30.8799 91.8499 27.4999 88.4699 27.4999 84.3099C27.4999 80.1499 30.8799 76.7699 35.0399 76.7699ZM58.8299 349.4H11.1799V329.22H58.8299V349.4ZM58.8299 318.95H11.1799V306.26C11.1799 267.27 17.0399 201.83 19.3199 177.77H50.6499C52.9099 202.57 58.8299 270.82 58.8299 306.26V318.95Z" fill="black"/>
</g>

<g class="logo-pen3">
<path d="M60.6304 122.24V72.2L52.2903 53.4799V28.4399H41.0304V0.939941H28.9604V28.4399H17.7004V53.4799L9.36035 72.2V122.24H0.900391V1117.1C0.900391 1126.31 8.36037 1133.77 17.5704 1133.77H52.4304C61.6404 1133.77 69.1003 1126.31 69.1003 1117.1V122.24H60.6404H60.6304ZM58.8304 342.98V350.67H11.1804V330.49H58.8304V342.97V342.98ZM58.8304 320.23H11.1804V179.05H58.8304V320.23Z" fill="black"/>
<path d="M58.8199 179.05H11.1699V320.23H58.8199V179.05Z" fill="white"/>
<path d="M11.1699 342.98V350.68H58.83V342.98V330.5H11.1699V342.98Z" fill="white"/>
</g>
    </svg>
  </div>
  </template>

<script setup lang="ts">import { computed } from 'vue'

interface Props {
  size?: number
  animate?: boolean
}

withDefaults(defineProps<Props>(), {
  size: 120,
  animate: true
})

const colors = [
  '#e74c3c', // Vibrant red (danger)
  '#3498db', // Sky blue (info)
  '#2ecc71', // Emerald green (success)
  '#f39c12', // Golden orange (warning)
  '#9b59b6', // Royal purple (purple)
  '#1a1a1a', // Deep charcoal (neutral)
  '#f8f8f8', // Warm white (neutral-light)
  'transparent', // Transparent with red stroke
  'transparent', // Transparent with blue stroke
]

const strokeColors = [
  undefined, // No stroke for filled circles
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  '#e74c3c', // Red stroke for transparent
  '#3498db', // Blue stroke for transparent
]

const circles = computed(() => {
  const centerX = 512
  const centerY = 512
  const radius = 350
  const circleRadius = 100
  
  const generatedCircles = []

  for (let i = 0; i < colors.length; i++) {
    const angle = (i * 360) / colors.length
    const x = centerX + Math.cos(angle * Math.PI / 180) * radius
    const y = centerY + Math.sin(angle * Math.PI / 180) * radius
    
    generatedCircles.push({
      cx: x,
      cy: y,
      r: circleRadius,
      fill: colors[i],
      stroke: strokeColors[i],
      strokeWidth: strokeColors[i] ? 2 : undefined
    })
  }
  
  return generatedCircles
})</script>

<style scoped>
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-svg {
  width: 100%;
  height: 100%;
}


.logo-circles {
  transform-origin: 512px 512px; 
  animation: rotateFast 4s linear infinite;
}


.logo-pen1 {
  transform: translateX(222px) translateY(1200px) scale(1.3);
  animation: penSlideUp1 0.3s ease-out 0s forwards;
}

.logo-pen2 {
  transform: translateX(478px) translateY(1200px) scale(1.3);
  animation: penSlideUp2 0.3s ease-out 0.3s forwards;
}

.logo-pen3 {
  transform: translateX(734px) translateY(1200px) scale(1.3);
  animation: penSlideUp3 0.3s ease-out 0.6s forwards;
}


@keyframes rotateFast {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes penSlideUp1 {
  0% {
    transform: translateY(1200px) translateX(222px) scale(1.3);
  }
  100% {
    transform: translateY(400px) translateX(222px) scale(1.3);
  }
}

@keyframes penSlideUp2 {
  0% {
    transform: translateY(1200px) translateX(478px) scale(1.3);
  }
  100% {
    transform: translateY(380px) translateX(478px) scale(1.3);
  }
}

@keyframes penSlideUp3 {
  0% {
    transform: translateY(1200px) translateX(734px) scale(1.3);
  }
  100% {
    transform: translateY(400px) translateX(734px) scale(1.3);
  }
}


.logo-pen1 {
  --pen-x: 222px;
}

.logo-pen2 {
  --pen-x: 478px;
}

.logo-pen3 {
  --pen-x: 734px;
}
</style>